const forms = {
  onRequest: "ตามคำขอร้อง", // translated
  person: "บุคคล", // translated
  travelDate: "วันที่เดินทาง", // translated
  travelDates: "วันเดินทาง", // translated
  cancel: "ยกเลิก", // translated
  getPrice: "รับราคา", // translated
};


export default forms;
